import { createContext, useContext } from 'react';

export interface ShellApi {
  openMenu: () => void;
  openStats: () => void;
}

/** Defaults are inert; `Shell` (Task 12) provides the real handlers. */
const ShellContext = createContext<ShellApi>({
  openMenu: () => {},
  openStats: () => {},
});

export const ShellProvider = ShellContext.Provider;

export function useShell(): ShellApi {
  return useContext(ShellContext);
}
